export const UserTourBookingData = [
  {
    key: "1",
    id: "#TR-1245",
    tourimage: "assets/img/tours/tours-20.jpg",
    tourname: "Joy Jubilee Jamboree",
    tourtype: "Adventure tourism",
    travellers: "2 Adults, 1 Child",
    day: "4 Days",
    pricing: "$11,569",
    date: "15 May 2025",
    status: "Upcoming",
    action: "upcoming",
  },
  {
    key: "2",
    id: "#TR-3215",
    tourimage: "assets/img/tours/tours-21.jpg",
    tourname: "LaughFest Carnival",
    tourtype: "Escorted tour",
    travellers: " 2 Adults, 2 Child",
    day: "3 Days",
    pricing: "$10,745",
    date: "20 May 2025",
    status: "Upcoming",
    action: "upcoming",
  },
  {
    key: "3",
    id: "#TR-4581",
    tourimage: "assets/img/tours/tours-22.jpg",
    tourname: "PlayPalooza Part",
    tourtype: "Ground tour",
    travellers: "2 Adults, 1 Child",
    day: "2 Days",
    pricing: "$8,160",
    date: "04 Jun 2025",
    status: "Upcoming",
    action: "upcoming",
  },
  {
    key: "4",
    id: "#TR-6545",
    tourimage: "assets/img/tours/tours-23.jpg",
    tourname: "Romantic Places ",
    tourtype: "Sightseeing tours",
    travellers: "1 Adult, 1 Child",
    day: "5 Days",
    pricing: "$14,840",
    date: "17 Jun 2025",
    status: "Pending",
    action: "pending",
  },
  {
    key: "5",
    id: "#TR-3256",
    tourimage: "assets/img/tours/tours-24.jpg",
    tourname: "Whimsy Wonderland ",
    tourtype: "Sightseeing tours",
    travellers: "2 Adults, 1 Child",
    day: "4 Days",
    pricing: "$10,450",
    date: "25 Jun 2025",
    status: "Upcoming",
    action: "upcoming",
  },
  {
    key: "6",
    id: "#TR-3654",
    tourimage: "assets/img/tours/tours-25.jpg",
    tourname: "Giggles & Games Gala ",
    tourtype: "Culinary tourism",
    travellers: "3 Adults, 2 Child",
    day: "3 Days",
    pricing: "$12,600",
    date: "02 Jul 2025",
    status: "Cancelled",
    action: "cancelled",
  },
  {
    key: "7",
    id: "#TR-1458",
    tourimage: "assets/img/tours/tours-26.jpg",
    tourname: "Fitness Frenzy",
    tourtype: "Domestic tour operators",
    travellers: "2 Adults, 2 Child",
    day: "2 Days",
    pricing: "$9,380",
    date: "12 Jul 2025",
    status: "Completed",
    action: "completed",
  },
  {
    key: "8",
    id: "#TR-6589",
    tourimage: "assets/img/tours/tours-27.jpg",
    tourname: "Foodie Fiesta",
    tourtype: "Newyork",
    travellers: "2 Adults, 1 Child",
    day: "5 Days",
    pricing: "$10,400",
    date: "26 Jul 2025",
    status: "Completed",
    action: "completed",
  },
  {
    key: "9",
    id: "#TR-2315",
    tourimage: "assets/img/tours/tours-28.jpg",
    tourname: "Dare DevCon",
    tourtype: "Agritourism",
    travellers: "2 Adults, 2 Child",
    day: "4 Days",
    pricing: "$12,810",
    date: "10 Aug 2025",
    status: "Completed",
    action: "completed",
  },
  {
    key: "10",
    id: "#TR-5414",
    tourimage: "assets/img/tours/tours-29.jpg",
    tourname: "Innovation Ignited",
    tourtype: "Romantic",
    travellers: "3 Adults, 1 Child",
    day: "3 Days",
    pricing: "$15,450",
    date: "22 Aug 2025",
    status: "Completed",
    action: "completed",
  },

];
